import styled from 'styled-components'
import { Navbar, Container } from 'react-bootstrap'
import { theme } from './../../common'

export const StyledBrand = styled(Navbar.Brand)`
    position: absolute;
    top: -24px;
    background-color: ${theme.white};
    padding-right: 5%;
    padding-left: 5%;
    border-radius: 0 0 10% 10%;
    z-index: 10;
    img {
        max-width: 135px;
        height: auto;
        width: 100%;
    }

    @media screen and (max-width: 991px) {
        position: static;
        top: 0px;
        padding: 0;
        background-color: transparent;
        img {
            max-width: 30px;
            border-radius: none;
        }
    }
`
export const StyledContainer = styled(Container)`
    flex-grow: 1;
`